// =========================================================
// * Vuetify Material Dashboard - v1.0.0
// =========================================================

// * Product Page: https://www.creative-tim.com/product/vuetify-material-dashboard
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
// * Licenses under MIT

// * Coded by Creative Tim

// =========================================================

// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import fb from './db';
import Vue from 'vue';
import i18n from './i18n';
// Components
import './components';

// Plugins
import './plugins';
import { sync } from 'vuex-router-sync';

// Application imports
import App from './App';
import router from '@/router';
import store from '@/store';
import api from './api';
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import VuetifyDialog from 'vuetify-dialog';
import 'vuetify-dialog/dist/vuetify-dialog.css';
import utils from './utils.js';

Vue.config.devtools = true;

Vue.use(VuetifyDialog, {
  confirm: {
    actions: {
      false: {
        text: 'cancel',
        color: 'orange',
        theme: 'dark',
      },
      true: {
        text: 'Confirm',
        color: 'orange',
        theme: 'dark',
      },
    },
  },
});
// Sync store with router
sync(store, router);
Vue.config.productionTip = false;
Vue.use(Loading, { color: 'primary', backgroundColor: '#000' });

Vue.mixin({
  methods: {
    uploadFile: function(file) {
      let formData = new FormData();
      formData.append('file', file);

      this.axios
        .post('http://localhost/shop-server/index.php/upload/image', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(function(data) {
          return data.data;
        })
        .catch(function() {
          return { status: 'failed' };
        });
    },
    price: utils.price,
    discountedPrice: utils.discountedPrice,
  },
});
router.beforeEach((to, from, next) => {
  const currentUser = fb.auth().currentUser;

  if (currentUser) {
    if (to.path != '/login') next();
    else next('/');
  } else if (!currentUser && to.path != '/login') {
    next('/login');
  } else {
    next();
  }
});
/* eslint-disable no-new */
let app;
fb.auth().onAuthStateChanged(async user => {
  if (!app) {
    app = new Vue({
      i18n,
      router,
      store,
      render: h => h(App),
    }).$mount('#app');
  }
  if (user) {
    if (router.currentRoute.path == '/login') router.replace('/');
    var u = await fb.auth().currentUser.getIdTokenResult();
    user.claims = u.claims;
    store.dispatch('fetchUser', user);
    let loader = app.$loading.show();
    api
      .get('admins/get/my/shops')
      .then(function(r) {
        // body...
        loader.hide();
        if (r.data.length > 1) {
          if (window.localStorage.vid) {
            store.dispatch('fetchVendors', r.data);
            store.dispatch('selectVid', JSON.parse(window.localStorage.vid));
          } else {
            store.dispatch('fetchVendors', r.data);
            store.dispatch('selectVid', r.data[0].id);
          }
        } else {
          store.dispatch('fetchVendors', r.data);
          store.dispatch('selectVid', r.data[0].id);
        }
      })
      .catch(async err => {
        loader.hide();
        if (err.message == 'Network Error') {
          const res = await app.$dialog.confirm({
            text: 'Please check your internet connection and try again',
            title: 'Connection Failed',
            actions: [
              { text: 'Cancel', color: 'orange', key: false },
              { text: 'Retry', color: 'orange', key: true },
            ],
          });
          if (res) {
            window.location.reload();
          }
        }
      });
  } else {
    router.replace('/login');
    store.dispatch('fetchUser', null);
  }
});
